import { service } from '../../../../helpers/http' 

export const ActionGetHours = ({ dispatch }, payload) => { 
    return service({
        module: 'domainHour',
        action: 'getHours',
        payload: payload
    })
}

export const ActionPostHours = ({ dispatch }, payload) => {

    return service({
        module: 'domainHour',
        action: 'postHours',
        payload: payload
    })
    
}

export const ActionPutHours = ({ dispatch }, payload) => {

    return service({
        module: 'domainHour',
        action: 'putHours',
        payload: payload
    })
    
}

export const ActionDeleteHours = ({ dispatch }, payload) => {

    return service({
        module: 'domainHour',
        action: 'deleteHours',
        payload: payload
    })
    
}


// Buscas exclusivas nas tabelas de integração de horários
export const ActionGetIntegrationHours = ({ dispatch }, payload) => { 
    return service({
        module: 'domainHour',
        action: 'getIntegrationHours',
        payload: payload
    })
}

export const ActionPostIntegrationHours = ({ dispatch }, payload) => {

    return service({
        module: 'domainHour',
        action: 'postIntegrationHours',
        payload: payload
    })
    
}

export const ActionPutIntegrationHours = ({ dispatch }, payload) => {

    return service({
        module: 'domainHour',
        action: 'putIntegrationHours',
        payload: payload
    })
    
}

export const ActionDeleteIntegrationHours = ({ dispatch }, payload) => {

    return service({
        module: 'domainHour',
        action: 'deleteIntegrationHours',
        payload: payload
    })
    
}